import React from "react";
import { Box, Typography, Avatar, Button } from "@mui/material";

export default function Error({ handleReset, client, company, lang, t }) {
  return (
    <Box
      display="flex"
    //   gap={2}
    //   px={2}
    //   py={1.5}
    //   borderRadius={2}
      sx={{
        backgroundColor: "#ffe5e5",
        border: "1px solid #ffb3b3",
        color: "#b30000",
        fontSize: "14px",
        lineHeight: 1.4,
        my: 1.5,
        alignItems: 'center',
        justifyContent: 'center',
        justifyItems: 'center',
        alignContent: 'center',
        display: 'flex'
      }}
    >
      {/* Avatar */}
      <Avatar
        src={client?.logo_url}
        alt="Admin"
        sx={{
          width: 40,
          height: 40,
          border: "1px solid #ddd",
        }}
      />

      {/* Text content */}
      <Box flex={1}>
        <Typography variant="body2">
          {t("initErrorMessage", lang)}
        </Typography>

        <Typography variant="body2">
          {t("contactMessage", lang)}
          {company?.client_phone ? ` (${company.client_phone}) ` : " "}
          {t("or", lang)}{" "}
          
          {/* Button inline */}
          <Button
            onClick={handleReset}
            size="small"
            variant="contained"
            sx={{
              backgroundColor: "#b30000",
              textTransform: "none",
            //   ml: 1,
              "&:hover": {
                backgroundColor: "#990000",
              },
            }}
          >
            {t("restartConversation", lang)}
          </Button>
        </Typography>
      </Box>
    </Box>
  );
}